import useModifyProviderDetails from "../../hooks/useModifyProviderDetails";
import { useProviderDetailPermissions } from "../../hooks/useProviderDetailPermissions";
import EditButton from "../buttons/EditButton";

import ProviderField from "./ProviderField";
import ProviderTypeChip from "./ProviderTypeChip";

export default function ProviderTypeList({ data }) {
  const { handleOnClickEditButton } = useModifyProviderDetails();
  const { canEditAllProviderFields } = useProviderDetailPermissions();

  return (
    <div className="flex flex-row items-center justify-between">
      <ProviderField
        label="Provider Type"
        data={data}
        renderValue={(items) => (
          <div className="flex flex-wrap gap-2">
            {items.map((item) => (
              <ProviderTypeChip key={item.id} label={item.name} />
            ))}
          </div>
        )}
      />
      <EditButton
        disabled={!canEditAllProviderFields}
        handleOnClick={canEditAllProviderFields ? handleOnClickEditButton : undefined}
      />
    </div>
  );
}
